import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { domainState, listDomains } from '../domainSlice';
import { DomainStore } from '../models/Domain.interface';


export const useDomains = (): [boolean, DomainStore[]] => {
    const dispatch = useAppDispatch();
    const { list } = useAppSelector(domainState);

    useEffect(() => {
        if (!list.isLoading && !list.isSuccess) {
            dispatch(listDomains());
        }
    }, [list]);

    return [list.isLoading, list.domains]
}
